import { z } from 'zod';

export const CustomTextInputLiteral = z.literal('Custom:TextInput');
export type CustomTextInput = z.infer<typeof CustomTextInputLiteral>;

export const CustomTextAreaLiteral = z.literal('Custom:TextArea');
export type CustomTextArea = z.infer<typeof CustomTextAreaLiteral>;

export const CustomFileUploadLiteral = z.literal('Custom:FileUpload');
export type CustomFileUpload = z.infer<typeof CustomFileUploadLiteral>;

export const CustomCheckboxLiteral = z.literal('Custom:Checkbox');
export type CustomCheckbox = z.infer<typeof CustomCheckboxLiteral>;

export const CustomSelectLiteral = z.literal('Custom:Select');
export type CustomSelect = z.infer<typeof CustomSelectLiteral>;

export const ComponentBlockSchema = z.union([
  CustomTextInputLiteral,
  CustomFileUploadLiteral,
  CustomCheckboxLiteral,
  CustomSelectLiteral,
  CustomTextAreaLiteral
]);

export type ComponentBlock = z.infer<typeof ComponentBlockSchema>;
